import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className=""><p style={{paddingBottom: '0px !important'}}>
                                                <span
                                                    className="subtiltereg bold">So, how can this be used in reverse?</span>
                                            </p></div>
                                            <ol className="blackOL">
                                                <li className="bold-li"><p><span><span
                                                    className="subtiltereg font">Name and label things to get a common frame of reference</span> and ensure people have a
common understanding of these as you move through your explanation. Be consistent in
this and check you’re being understood.</span></p></li>
                                                <li className="bold-li"><p><span><span
                                                    className="subtiltereg font"> Do not put yourself under time pressure</span> when trying to explain complex issues. They take
time, so create the time. Plan your use of the time effectively.</span></p></li>
                                                <li className="bold-li"><p><span><span
                                                    className="subtiltereg font">Use as wide a range of communication channels</span> as you can. Try to use the communication
channel that best meets the needs of the audience. For example, if your audience really like
to picture things then consider using a PowerPoint presentation with slides of visual images.</span></p></li>
                                                <li className="bold-li"><p><span><span
                                                    className="subtiltereg font">Control your audience.</span> Set rules for how you want them to interact with you. Check that
they understand your thinking and give them rules for asking questions or interrupting if
they don’t understand.
</span></p></li>
                                                <li className="bold-li"><p><span><span
                                                    className="subtiltereg font">Use non-verbal communications</span> to check if others understand your points. Are they looking
bored or lost? Use your non-verbal skills such as eye contact, gestures, etc. to support and
emphasise key points.</span></p></li>
                                            </ol>
                                            <div className="circle_title pad-lft sept"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
PREFERENCES IN GIVING AND RECEIVING INFORMATION
</span></div>
                                            <p>The Myers Briggs Type Indicator (MBTI)®<a
                                                className="superscripttext"
                                                href="further_info.php?course=300"><sup>3</sup></a> personality
                                                profile is one way to consider how we like
                                                to give information to others and how they like to receive
                                                it.</p>
                                            <p>If you already know your MBTI, then skip to the next section,
                                                which is all about applying your
                                                MBTI type. If not, have a look at the following
                                                exercises.</p>
                                            <p>There are 4 dimensions on the MBTI (Extraversion-Intraversion
                                                (E-I), Sensing-Intuition (S-N),
                                                Thinking-Feeling (T-F) and Judging-Perceiving (J-P)). Each
                                                dimension has two sides and a
                                                person selects the profile they consider most like
                                                themselves. For example, if you feel you’re
                                                someone who prefers information that’s real and tangible,
                                                then you are likely to be Sensing (S).
                                                The MBTI dimension most relevant to complex thinking is S
                                                (Sensing) and N (Intuition).</p>
                                            <p>Read the descriptors below and select whether you are more S
                                                or more N. You may feel that you
                                                have characteristics from both but select the one that, on
                                                balance, is most like you.</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport ilead_v_sport_new_task tablesrink">
                                                <tbody>
                                                <tr>
                                                    <th width="50%" align="left" valign="center"
                                                        className="green_curve ">Sensing
                                                    </th>
                                                    <th width="50%" align="left" valign="top"
                                                        className="green_curve1">Intuition
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <ul className="greenbullet-list">
                                                            <li><p>Focused on the present</p></li>
                                                            <li><p> Factual and concrete</p></li>
                                                            <li><p> Focus on what is real and actual</p>
                                                            </li>
                                                            <li><p> Observe and remember details</p></li>
                                                            <li><p> Build carefully and thoroughly
                                                                towards conclusions</p></li>
                                                            <li><p>Understand ideas and theories
                                                                through practical applications</p></li>
                                                            <li className="cntareap paraspace"><p>Trust
                                                                experience</p></li>

                                                        </ul>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <ul className="greenbullet-list">
                                                            <li><p>Oriented to future possibilities</p></li>
                                                            <li><p> Imaginative and verbally creative</p>
                                                            </li>
                                                            <li><p>Focus on patterns and meanings in
                                                                data</p></li>
                                                            <li><p> Remember details when they relate to
                                                                a pattern</p></li>
                                                            <li><p> Move quickly to conclusions, follow
                                                                hunches</p></li>
                                                            <li><p>Want to clarify ideas and theories before
                                                                putting them into practice</p></li>
                                                            <li className="cntareap paraspace"><p>Trust
                                                                inspiration
                                                            </p></li>

                                                        </ul>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}